let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("awj6q")).then(() => parcelRequire('hCM3u'));